import React from 'react';

function FeatureText(props) {
    return (
        <>{props.flag
            ?
            <li className="text-muted ">
                <span className=' text-success h5 me-1'>
                    <i className=' uil uil-check-circle align-middle'>
                    </i>
                </span>
                {props.value}
            </li>
            :
            <li className="text-muted ">
                <span className=' text-danger h5 me-1'>
                    <i className=' uil uil-times-circle align-middle'>
                    </i>
                </span>
                {props.value}
            </li>
        }</>
    );
}

export default FeatureText;
